import ActionTypes from "../constants/ActionTypes";
import axiosInstance from "../helpers/refreshTokenMiddleware";
import BASE_URL from '../constants/Api';

/* =========================================================
 * データ件数取得処理
 * ========================================================= */
export const fetchCountRequest = () => ({
    type: ActionTypes.FETCH_DATA_COUNT_REQUEST,
});

export const fetchCountSuccess = (data) => ({
    type: ActionTypes.FETCH_DATA_COUNT_SUCCESS,
    payload: data,
});

export const fetchCountFailure = (error) => ({
    type: ActionTypes.FETCH_DATA_COUNT_FAILURE,
    payload: error,
});

export const fetchDataCount = (folderId) => async (dispatch) => {
  dispatch(fetchCountRequest());
  try {
    const response = await axiosInstance.post(`${BASE_URL}/top/datamanage-count`, {
      folder_id: folderId,
      // is_delete: [0],
    });

    const { count, keys } = response.data.respons;

    dispatch(fetchCountSuccess({ count, keys }));

  } catch (error) {
    console.error("fetchDataCount error:", error);
    dispatch(fetchCountFailure(error.message || "件数取得中にエラーが発生しました。"));
  }
};

/* =========================================================
 * データ一覧取得処理
 * ========================================================= */
export const fetchDataFolderRequest = () => ({
    type: ActionTypes.FETCH_DATA_FOLDER_REQUEST,
});

export const fetchDataFolderSuccess = (data, headers) => ({
    type: ActionTypes.FETCH_DATA_FOLDER_SUCCESS,
    payload: { data, headers },
});

export const fetchDataFolderFailure = (error) => ({
    type: ActionTypes.FETCH_DATA_FOLDER_FAILURE,
    payload: error,
});

export const fetchDataFolder = (params = {}) => async (dispatch) => {
  dispatch(fetchDataFolderRequest());

  try {
    const response = await axiosInstance.post(`${BASE_URL}/top/datamanage`, {
      folder_id: params.folder_id ?? null,
      department_id: params.department_id ?? null,
      header_flag: params.header_flag ?? null,
      key: params.key ?? null,
    });

    const { data, headers, last_key } = response.data.respons;
    dispatch(fetchDataFolderSuccess(data, headers, last_key));
  } catch (error) {
    dispatch(fetchDataFolderFailure(error.message));
  }
};

